import { TimelineMax, Expo } from 'gsap';

import hades from '@/scripts/hades';
import utils from '@/scripts/utils';

export function defaultIn(el, delay) {
  const tl = new TimelineMax({
    delay,
  });

  const footer = document.querySelector('footer');
  const info = document.querySelector('.footer__info');
  const aside = Array.from(document.querySelectorAll('aside'));

  tl
    .addLabel('start')
    .set(el, {
      autoAlpha: 1,
    }, 'start')
    .set([footer, info, aside], {
      autoAlpha: 1,
    }, 'start')

  return tl;
}

export function defaultOut(el) {
  const tl = new TimelineMax();

  const scrollY = hades.ref.amount.y;

  const footer = document.querySelector('footer');
  const info = document.querySelector('.footer__info');
  const aside = Array.from(document.querySelectorAll('aside'));

  tl
    .addLabel('start')
    .set(el, {
      position: 'absolute',
      maxWidth: '100vw',
      width: '100%',
      zIndex: 5,
      y: scrollY * -1,
      pointerEvents: 'none',
    }, 'start')
    .to([footer, info, aside], 2, {
      autoAlpha: 0,
      ease: Expo.easeInOut,
    }, 'start')
    .to(el, 2, {
      x: window.innerWidth / -1.5,
      ease: Expo.easeInOut,
    }, 'start')
    .to(el.children, 0.5, {
      autoAlpha: 0,
      ease: Expo.easeInOut,
    }, 'start+=0.25');

  return tl;
}